module.exports = __webpack_public_path__ + "static/media/mls@3x.bbfd2037.png";